<template>
  <div id="app">
    <vue-headful
      :title="meta.title"
      :description="meta.description"
      :html="{ body: {id: $route.meta.id } }"
      :lang="$route.meta.lang"
      :head="{
        'link[rel^=shortcut]': {href: meta.favicon},
        'link[rel=apple-touch-icon]': {href: meta.appleicon},

        'link[rel=canonical]': {href: meta.url},

        'meta[property^=og][property$=title]': {content: meta.title},
        'meta[property^=og][property$=image]': {content: meta.img},
        'meta[property^=og][property$=url]': {content: meta.url},
        'meta[property^=og][property$=description]': {content: meta.description},

        'meta[name^=twitter][name$=title]': {content: meta.title},
        'meta[name^=twitter][name$=image]': {content: meta.img},
        'meta[name^=twitter][name$=description]': {content: meta.description},

        'meta[name=author]': {content: meta.author},

        'link#preload-0': preload[0],
        'link#preload-1': preload[1],
        'link#preload-2': preload[2],
        'link#preload-3': preload[3],
        'link#preload-4': preload[4],
        'link#preload-5': preload[5],
        'link#preload-6': preload[6],
        'link#preload-7': preload[7],
        'link#preload-8': preload[8],
        'link#preload-9': preload[9],
      }"
    />
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',

  data() {
    /* Title */
    let title = this.$t('meta.title', '-t'); // Main title

    if (this.$te(`${this.$route.meta.id}.title`)) {
      // Main title - Page title
      title = `${title} - ${this.$t(`${this.$route.meta.id}.title`, '-t')}`;
    }

    /* Description */
    const description = this.$te(`meta.${this.$route.meta.id}.description`)
      ? this.$t(`meta.${this.$route.meta.id}.description`)
      : this.$t('meta.description', '-t');

    /* Preload */
    const preload = []; /* array of { href: '', as: '' } */
    const nodes = 10; /* link[rel="preload"] in index.html */
    let preloadList = []; /* main and route files to preload  */
    const mainList = this.$te('meta.preload') ? this.$t('meta.preload') : [];
    const routeList = this.$te(`meta.${this.$route.meta.id}.preload`)
      ? this.$t(`meta.${this.$route.meta.id}.preload`)
      : [];

    /* merge main (in first) and route (in priority) list */
    preloadList = mainList.slice(0, (nodes - routeList.length)).concat(routeList);

    /* Fill with empty string */
    while (preloadList.length < nodes) {
      preloadList.push('');
    }

    for (let i = 0; i < preloadList.length; i += 1) {
      let type = '';
      if (/\.(png|jpg|gif|webp)$/.test(preloadList[i])) { type = 'image'; }
      if (/\.(ttf|eot|woff|woff2)$/.test(preloadList[i])) { type = 'font'; }
      if (/\.(webm|mp4)$/.test(preloadList[i])) { type = 'video'; }

      preload[i] = {
        href: preloadList[i].replace(/^\//, this.$t('baseurl')),
        as: type,
      };
    }

    return {
      meta: {
        title,
        description,
        author: this.$te('meta.author') ? this.$t('meta.author') : '',
        img: `${this.$t('baseurl')}img/opengraph/${this.$route.meta.id}.jpg`,
        url: `${this.$t('meta.canonical')}${this.$route.path}`,
        favicon: `${this.$t('baseurl')}img/icons/favicon.png`,
        appleicon: `${this.$t('baseurl')}img/icons/apple-touch-icon.png`,
      },
      i18n: process.env.NODE_ENV !== 'prod' ? this.$i18n.messages : '',
      preload,
    };
  },

  created() {
    if (this.$route.meta.lang !== undefined
      && this.$i18n.locale !== this.$route.meta.lang) {
      this.$i18n.locale = this.$route.meta.lang;
    }
  },
};
</script>
